import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Activity} from '../../../../models/applicationFeature';
import {CommonService} from '../../../../services/common.service';
import {NotificationService} from '../../../../services/notification.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';

@Component({
    selector: 'app-complete-affirmation-dialog',
    templateUrl: './complete-affirmation-dialog.component.html',
    styleUrls: ['./complete-affirmation-dialog.component.scss']
})
export class CompleteAffirmationDialogComponent implements OnInit {
    affirmation: any;
    children: any;
    affirmationAnnouncementContent: string;
    @ViewChild('divElement', {static: false}) divElement: ElementRef;
    selectedChild: any;
    selectedParent: any;
    isLoading: boolean;
    editorStylePreview: any;
    selectedActivity: Activity;
    parent: any;
    currentParents = [];
    parentDisplayName: string;
    affirmationId: number;
    htmlContent = '';
    comments: string;
    selectedLevel: any;
    childId: number;
    affirmationUniqueId: string;
    mode: string;
    childDisplayName: string;
    notificationId: number;
    showTwoFactor = false;
    code = '';
    parentId: number;

    constructor(private route: ActivatedRoute,
                private router: Router,
                public notificationService: NotificationService,
                private commonService: CommonService,
                public toastMessagesService: ToastMessagesService) {
        this.affirmationAnnouncementContent = '';
        this.parentDisplayName = '';
        this.childDisplayName = '';
        this.editorStylePreview = {height: '100%;', border: '0px'};
        this.isLoading = true;
        this.comments = '';
    }

    async ngOnInit() {
        this.route.queryParams.subscribe(async (params) => {
            this.affirmationUniqueId = params.unique_id;
            this.notificationId = +params.notificationId;
            this.mode = params.mode;
            this.childId = params.childId;
            await this.initAffirmation();
            if (this.childId) {
                await this.initChild();
            }
            if (params.parentId) {
                this.parentId = +params.parentId;
                await this.initParent();
            }
            await this.initActivity();
            this.isLoading = false;

            // console.log(this.affirmation);
            console.log(this.mode);
        });
    }

    async initChild() {
        try {
            const childRequest = await this.commonService.getList(`children/info?id=${this.childId}`);
            this.selectedChild = childRequest.object[0];
            this.selectedChild.displayName = `${this.selectedChild.firstName} ${this.selectedChild.lastName}`;
            this.childDisplayName = `${this.selectedChild.firstName} ${this.selectedChild.lastName}`;
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    async initAffirmation() {
        try {
            // const affirmationRequest = await this.commonService.getList(`affirmations?id=${this.affirmationId}`);
            const affirmationRequest = await this.commonService.getList(`forms?unique_id=${this.affirmationUniqueId}`);

            this.affirmation = affirmationRequest.object[0];
            this.affirmationId = this.affirmation.id;
            console.log(this.affirmationId);
            this.htmlContent = JSON.parse(this.affirmation.content);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    async initActivity() {
        try {
            const activitiesRequest = await this.commonService.getList(`activities?id=${this.affirmation.activity_id}`);
            for (const activity of activitiesRequest.object) {
                const levelsRequest = await this.commonService.getList(`activities/assign?id=${activity.id}`);
                activity.assignedLevels = levelsRequest.object;
            }
            this.selectedActivity = activitiesRequest.object[0];
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    async initParent() {
        try {
            const parentRequest = await this.commonService.getList(`people/parent`);
            this.parent = parentRequest.object[0];
            this.parentDisplayName = `${this.parent.first_name} ${this.parent.last_name}`;
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    async submitAffirmation() {
        if (this.affirmation.has_two_factor) {
            this.showTwoFactor = true;
            await this.requestCode();
        } else {
            await this.finalizeAffirmation();
        }
    }

    async validateCode() {
        try {
            const response = await this.submitTwoFactorCode();

            if (response && response.status === 200) {
                await this.finalizeAffirmation();
            } else {
                this.toastMessagesService.toastErrorMessage('Ο κωδικός που πληκτρολογήσατε δεν είναι σωστός');
            }
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(`Ο κωδικός που πληκτρολογήσατε δεν είναι σωστός`);
        } finally {

        }
    }

    async requestCode() {
        const model = {
            activityId: this.selectedActivity.id,
            formUniqueId: this.affirmation.unique_id,
            childId: this.childId
        };

        try {
            // tslint:disable-next-line:max-line-length
            const response: any = await this.commonService.updateItem(`twoStep/affirmations`, model);
            console.log(response);
            this.toastMessagesService.toastMessages(response.object.message);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    private async finalizeAffirmation() {
        const model = {
            child_id: this.selectedChild.id,
            activity_id: this.affirmation.activity_id,
            activity_level: this.selectedLevel,
            unique_id: this.affirmation.unique_id,
            notification_id: this.notificationId,
            comments: this.comments ? JSON.stringify(this.comments) : ''
        };
        try {
            await this.commonService.updateItem('affirmations/enroll', model);
            await this.notificationService.getAllNotifications(+this.parentId, true);
            this.toastMessagesService.toastMessages('Η εγγραφή ολοκληρώθηκε με επιτυχία');
            await this.router.navigate(['/home']);
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }

    private async submitTwoFactorCode() {
        try {
            const model = {
                code: this.code,
                activityId: this.selectedActivity.id,
                formUniqueId: this.affirmation.unique_id,
                childId: this.childId
            };
            const response: any = await this.commonService.insertItem(`twoStep/affirmations/authStep`, model);
            return response;
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        }
    }
}
